import PlaySession from './PlaySession';
import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";
import ScenarioPlaySession from './ScenarioPlaySession';

/**
 * PlaySessionModel.js
 * 
 * Created on Oct 9, 2013, 3:26:00 PM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class PlaySessionModel {

    constructor() {
        this._scenarioSessions = [];
    }

    /*
     * Starts a new game session
     */
    startNewGameSession() {
        this._currentGameSession = new PlaySession();
    };

    /**
     * 
     * @param {string} scenarioID
     * @returns {ScenarioPlaySession}; 
     */
    startNewScenarioSession(scenarioID) {
        var scoreSession = new ScenarioPlaySession();
        scoreSession.setScenarioID(scenarioID);
        this._scenarioSessions.push(scoreSession);
        this._currentScenarioSession = scoreSession;
    };

    getCurrentGameSession() {
        return this._currentGameSession;
    };

    /**
     * 
     * @returns {ScenarioPlaySession}
     */
    getCurrentScenarioSession() {
        return this._currentScenarioSession;
    };

    getScenarioSessions() {
        return this._scenarioSessions;
    };

    setScenarioSessions(value) {
        if (isNull(value))
            this._scenarioSessions = [];
        else
            this._scenarioSessions = value;
    };

    load(persistentCopy) {
        if (!isNull(persistentCopy)) {
            if (persistentCopy instanceof PlaySessionModel) {
                this._scenarioSessions = persistentCopy.getScenarioSessions();
            }
        }
    };
}